import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/ledger-state-engine/page.tsx");
